"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const path = require("path");
const fs = require("fs");
const resolveNodeDeps = require("snyk-resolve-deps");
const baseDebug = require("debug");
const lodash_1 = require("lodash");
const utils_1 = require("./utils");
const debug = baseDebug('snyk-nodejs-plugin');
function parse(root, targetFile, options) {
    if (options.includeComponentMetadata) {
        debug('includeComponentMetadata is set but resolving via node_modules (no lockfile); ' +
            'package hash / distribution URL labels are only reported from lockfiles, skipping');
    }
    if (targetFile.endsWith('yarn.lock')) {
        options.file =
            options.file && options.file.replace('yarn.lock', 'package.json');
    }
    if (targetFile.endsWith('pnpm-lock.yaml')) {
        options.file =
            options.file && options.file.replace('pnpm-lock.yaml', 'package.json');
    }
    // package-lock.json falls back to package.json (used in wizard code)
    if (targetFile.endsWith('package-lock.json')) {
        options.file =
            options.file && options.file.replace('package-lock.json', 'package.json');
    }
    // check if there any dependencies
    const packageJsonFileName = path.resolve(root, options.file);
    const packageManager = options.packageManager || 'npm';
    try {
        const packageJson = JSON.parse((0, utils_1.getFileContents)(root, packageJsonFileName).content);
        let dependencies = packageJson.dependencies;
        if (options.dev) {
            dependencies = { ...dependencies, ...packageJson.devDependencies };
        }
        if ((0, lodash_1.isEmpty)(dependencies)) {
            return new Promise((resolve) => resolve({
                name: packageJson.name || 'package.json',
                dependencies: {},
                version: packageJson.version,
            }));
        }
    }
    catch (e) {
        debug(`Failed to read ${packageJsonFileName}: Error: ${e}`);
        throw new Error(`Failed to read ${packageJsonFileName}. Error: ${e.message}`);
    }
    const nodeModulesPath = path.join(path.dirname(path.resolve(root, targetFile)), 'node_modules');
    if (!fs.existsSync(nodeModulesPath)) {
        // throw a custom error
        throw new Error("Missing node_modules folder: we can't test " +
            `without dependencies.\nPlease run '${packageManager} install' first.`);
    }
    return resolveNodeDeps(root, Object.assign({}, options, { noFromArrays: true }));
}
//# sourceMappingURL=npm-modules-parser.js.map